<template>
  <div class="kw_list_collapse" :style="pageSetInfo.listStyleSet.listPageBoxStyleSet?pageSetInfo.listStyleSet.listPageBoxStyleSet.styleSetCode:''" kwName="listPageBoxStyleSet">
    <template class="introduceBox">
      <div v-if="(pageSetInfo.listStyleSet.scheduleHide == 2) && (dataList && dataList.length>1)">
            <div class="scheduleBox" :style="pageSetInfo.listStyleSet.listPageCollapseFieldStyleSet?pageSetInfo.listStyleSet.listPageCollapseFieldStyleSet.styleSetCode:''" kwName="listPageCollapseFieldStyleSet">
              <div v-for="(item,index) in dataList" :key="index">
                <div class="scheduleItem" @click="jumpTo('item'+index)" :data-opt="'item'+(index)">
                  <span class="scheduleIndex">{{index+1}}</span>
                  <span class="scheduleName">{{item.NAME}}</span>
                </div>
              </div>
        </div>
      </div>
      <template>
        <div v-for="(dataInfo,dataIndex) in dataList" :key="'BG_FILE_'+dataIndex" :style="pageSetInfo.listStyleSet.listPageCardCommonStyleSet?pageSetInfo.listStyleSet.listPageCardCommonStyleSet.styleSetCode:''" kwName="listPageCardCommonStyleSet">
          <div v-if="dataInfo.NAME" class="introduceTitle" :id="'item'+(dataIndex)" :style="pageSetInfo.listStyleSet.listPageFieldNameStyleSet?pageSetInfo.listStyleSet.listPageFieldNameStyleSet.styleSetCode:''" kwName="listPageFieldNameStyleSet">
            {{dataInfo.NAME}}
          </div>
          <template :class="((dataList && dataList.length>1)?'scheduleImageBox':'')">
            <div  v-if="(pageSetInfo.listStyleSet.scheduleLeftHide == 2)">
              <div class="scheduleIndex scheduleImageIndex" v-if="(dataList && dataList.length>1)">
                {{dataIndex+1}}
              </div>
            </div>
            <template>
              <pre class="introduceText" v-if="(dataInfo.TYPE==1)" :style="pageSetInfo.listStyleSet.listPageFieldValueStyleSet?pageSetInfo.listStyleSet.listPageFieldValueStyleSet.styleSetCode:''" kwName="listPageFieldValueStyleSet">{{dataInfo.CONTENT}}</pre>
              <video oncontextmenu="return false" :style="pageSetInfo.listStyleSet.pageFieldVideoStyleSet?pageSetInfo.listStyleSet.pageFieldVideoStyleSet.styleSetCode:''" kwName="pageFieldVideoStyleSet" v-else-if="(dataInfo.TYPE==3)" controls="controls" :src="(GLOBAL.getFileServeUrl()+dataInfo.BG_FILE)"></video>
              <div :style="pageSetInfo.listStyleSet.listPageFieldValueStyleSet?pageSetInfo.listStyleSet.listPageFieldValueStyleSet.styleSetCode:''" kwName="listPageFieldValueStyleSet" v-else-if="(dataInfo.TYPE==4)" v-html="dataInfo.EDITOR_CONTENT"></div>
              <kw_preview_image v-else-if="(dataInfo.BG_FILE)" zdyClass="imageStyle" :styleSet="(pageSetInfo.listStyleSet)" :imgSrc="(dataInfo.BG_FILE)"></kw_preview_image>
            </template>
          </template>
          <!-- 加号展开子页面  默认展开的 -->
          <div :class="('titBgList'+pageSetInfo.styleSet.titleStyle)">
            <div v-for="(item,index) in childTabs" :key="'tabPageId_'+index" >
              <div v-if="(item.styleSet.jumpWay != 3 && item.styleSet.jumpWay != 4)" >
                <div v-if="(item.styleSet.jumpWay == 2 || item.styleSet.setHeaderHide != 1)" :class="(pageSetInfo.styleSet.titleStyle && pageSetInfo.styleSet.titleStyle == 2?'ExaminationCurriculumTitle':pageSetInfo.styleSet.titleStyle == 3? 'curriculumTitleBg' :'curriculumTitle' )">
                  <div v-if="(pageSetInfo.styleSet.titleStyle==3)" class="titBgBox">
                    <img src="./img/titbg.png" alt="" class="titimg"/>
                    <span class="quanIcon"></span>
                    <span class="titNum">{{index+1}}</span>
                    <span class="tabnameImg" v-if="(item.styleSet.setHeaderHide != 1)" :style="item.styleSet.listPageCollapseFieldNameStyleSet?item.styleSet.listPageCollapseFieldNameStyleSet.styleSetCode:''" kwName="listPageCollapseFieldNameStyleSet">{{item.childPageName}}</span>
                    <span v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" :data-index="(index)" class="loadmore" :style="item.styleSet.listPageCollapseFieldValueStyleSet?item.styleSet.listPageCollapseFieldValueStyleSet.styleSetCode:''" kwName="listPageCollapseFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</span>
                  </div>
                  <div v-else>
                    <span class="tabname" v-if="(item.styleSet.setHeaderHide != 1)" :style="item.styleSet.listPageCollapseFieldNameStyleSet?item.styleSet.listPageCollapseFieldNameStyleSet.styleSetCode:''" kwName="listPageCollapseFieldNameStyleSet">{{item.childPageName}}</span>
                    <span v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" :data-index="(index)" class="loadmore" :style="item.styleSet.listPageCollapseFieldValueStyleSet?item.styleSet.listPageCollapseFieldValueStyleSet.styleSetCode:''" kwName="listPageCollapseFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</span>
                  </div>
                </div>
                <kw_list v-if="(item.ifLoad)" :ref="('kw_list_'+index)" :id="('kw_list_'+index)" :initPageObj="(item)" :mainId="(dataInfo.LMF_ID)" :isLimitButton="isLimitButton"></kw_list>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
      </template>
    </template>
  </div>
</template>

<script>
// 图片预览组件 kw_preview_image
import kw_preview_image from '@/components/look/kw_preview_image.vue';

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_list_collapse',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
    //可以选中几个数据
    dataMaxNum: {
      type: Number,
      value: 1
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oneCurrent: 0,
      oneIndex: 0,
      checkDataInfo: [],
      detailPageInfo: {},
      // 加号展开选项卡
      childTabs: [],
      toView:''
      // someData: {
      //   statusBarHeight: app.globalData.statusBarHeight,
      //   titleBarHeight: app.globalData.titleBarHeight
      // },
    }
  },
  created() {
    var that = this;
    var pageSetInfo = this.pageSetInfo;
    if (pageSetInfo.childTabs) {
      var childTabs = [];
      for (var i = 0; i < pageSetInfo.childTabs.length; i++) {
        var one = pageSetInfo.childTabs[i];
        // 如果是查看页面 进行数据处理
        // if (one.type == 1) {
        one.mainTableId = pageSetInfo.tableId;
        one.mainPageId = pageSetInfo.pageId;
        // }
        one.ifLoad = true;
        childTabs.push(one);
        console.log("one==========================", one);
      }
      that.childTabs = childTabs;
    }
    var dataList = this.dataList;
    if (dataList) {
      for (var i = 0; i < dataList.length; i++) {
        if (dataList[i].CONTENT) {
          dataList[i].CONTENT = dataList[i].CONTENT.replace(/_@/g, "\n");
        }
      }
    }
    that.dataList = dataList;
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_preview_image,
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    // 锚点定位
    jumpTo(opt) {
      // 获取标签元素上自定义的 data-opt 属性的值
      this.toView = opt;
    },
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 调用父级组件选中的回调事件
     */
    eventTrigger: function (e) {
      var oneCurrent = this.data.oneCurrent; //通过这个传递数据
      var checkDataInfo = this.data.checkDataInfo;
      var myEventDetail = {
        val: oneCurrent,
        checkDataInfo: checkDataInfo
      } // detail对象，提供给事件监听函数
      //this.triggerEvent('callbackevent', myEventDetail) //myevent自定义名称事件，父组件中使用
        this.$emit('callbackevent', myEventDetail) //myevent自定义名称事件，父组件中使用
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.introduceBox{background: #fff;}
.introduceTitle{padding: 30px 0 15px}
.redLine{display: inline-block;background: #FB3031;width: 4px;height: 16px;border-radius: 4px;margin-right: 2px}
.introduceName{font-size: 16px;font-weight: bold;color: #343434;}
.introduceText{font-size: 14px;color: #797979;padding: 0 20px;display: block;white-space: pre-line;}

.imageOrcontent{display: flex;justify-content: flex-start;align-items: center}

.imageOrcontent img{width: 100px;height: 100px;border-radius: 100px}
.contentBox{margin-left: 10px}
.contentBox span{color: #7D7D7D;font-size: 14px;}
.contentBox .contentName{color: #FB2F31;font-size: 16px;display: block;font-weight: bold}

.imageStyle{margin: 0 10px; display: block;width: 100%}



.scheduleBox{display: flex;flex-wrap: wrap;justify-content: space-between;margin: 0 10px;position: relative;padding-bottom: 10px;background:#fff;}
.scheduleBox:before{border-top: 1px dashed #FBAC47;content: ' ';display: inline-block;width: 80%;position: absolute;left: 40px;top: 13px}


.scheduleName{font-size: 12px;color: #717171}
.scheduleItem{display: flex;flex-direction: column;align-items: center}
.scheduleIndex{background: #FBAC47;color: #ffffff;height: 25px;width: 25px;border-radius: 25px;margin-bottom: 10px;line-height: 25px;text-align: center}

/* .scheduleItem:before{border-top: 1px dashed #FBAC47;content: ' ';display: inline-block;width: 100%;position: absolute;top: 45px} */

.scheduleImageBox{display: flex;justify-content: space-between}
.scheduleImageIndex{margin-left: 10px}
.newIntroduceName{padding: 0 0 20px 45px}

/* .scheduleImageBox:before{border-left: 1px dashed #FBAC47;content: ' ';display: inline-block;position: absolute;left: 22px;top: 90px;height: 100%} */

.jumpTo:before{border-left: 1px dashed #FBAC47;content: ' ';display: inline-block;position: absolute;left: 22px;top: 180px;height: 100%}
.tabname{padding: 0 10px;font-size: 16px}


</style>
